import React from 'react';
import './ModalHeader.scss';
import { ReactComponent as ArrowSquareRight } from '../../images/arrow-square-right.svg';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  border?: boolean;
  customContent?: React.ReactNode;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose, border, customContent }) => {
  return (
    <header className='modal-header' style={{ width: customContent ? '100%' : '' }}>
      <div
        className='modal-header-container'
        style={{ gap: border ? '4px' : '24px', display: 'flex', alignItems: 'center' }}
      >
        <div className='modal-icon-container'>
          <div className='modal-icon-wrapper'>
            <div className='modal-icon-flex' onClick={onClose}>
              <ArrowSquareRight width='24' height='24' stroke='#F4FBFC' />
            </div>
          </div>
        </div>
        {border && <div className='modal-header-border'></div>}
        <div className='modal-title-container'>
          <div className='modal-title-content'>{title}</div>
        </div>
        {customContent && (
          <div className='modal-custom-content' style={{ marginLeft: 'auto' }}>
            {customContent}
          </div>
        )}
      </div>
    </header>
  );
};

export default ModalHeader;
